import Nullstack from 'nullstack';
export default function IconSortZA({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-sort-z-a",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M4 8h4l-4 8h4"
  }), "   ", Nullstack.element("path", {
    d: "M16 16v-6a2 2 0 1 1 4 0v6"
  }), "   ", Nullstack.element("path", {
    d: "M16 13h4"
  }), "   ", Nullstack.element("path", {
    d: "M11 12h2"
  }), " ");
}